export const regexURL =
  /^(https?:\/\/)([a-zA-Z0-9\-._~%]+\.[a-zA-Z0-9\-._~%]+)(:[0-9]{1,5})?(\/[a-zA-Z0-9\-._~%!@:\/]*)?(\?[a-zA-Z0-9\-._~%!&=+:@\/]*)?(#[a-zA-Z0-9\-._~%!&=+:@\/]*)?$/u;
